import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IApiResponse, IMonitoramento } from '@/interfaces'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export class MonitoramentoService {
	/**
	 * Retorna a lista com as datas de ultima entrada, finalizacao e tempo de intervalo dos robos
	 * @returns Array<IMonitoramento>
	 */
	public static async getMonitoramentoRobos() {
		const response = await http.get<IApiResponse<Array<IMonitoramento>>>(`/monitoramento/robos`)
		return response.data
	}
}
